import ProfileData from 'components/ProfileData'

const ServiceDogDetails = ({data}) => {
  return (
    <ProfileData data={data} />
  )
}

export default ServiceDogDetails;
